type HeadParams = {
  title?: string;
  meta?: { name: string; content: string }[];
  link?: { rel: string; href: string }[];
  script?: { src: string }[];
  style?: { cssText: string }[];
  base?: { href: string }[];
};

export function useHead() {
  const setHead = (params: HeadParams) => {
    // Handle title
    if (params.title) {
      let titleEl = document.head.querySelector('title')
      if (!titleEl) {
        titleEl = document.createElement('title')
        document.head.appendChild(titleEl)
      }
      titleEl.textContent = params.title
    }

    // Handle meta tags
    params.meta?.forEach(({ name, content }) => {
      let el = document.head.querySelector<HTMLMetaElement>(
        `meta[name='${name}']`
      )
      if (!el) {
        el = document.createElement('meta')
        el.setAttribute('name', name)
        document.head.appendChild(el)
      }
      el.setAttribute('content', content)
    })

    // Handle link tags
    params.link?.forEach(({ rel, href }) => {
      let el = document.head.querySelector<HTMLLinkElement>(
        `link[rel='${rel}']`
      )
      if (!el) {
        el = document.createElement('link')
        el.setAttribute('rel', rel)
        document.head.appendChild(el)
      }
      el.setAttribute('href', href)
    })

    // Handle script tags
    params.script?.forEach(({ src }) => {
      let el = document.head.querySelector<HTMLScriptElement>(
        `script[src='${src}']`
      )
      if (!el) {
        el = document.createElement('script')
        el.setAttribute('src', src)
        document.head.appendChild(el)
      }
    })

    // Handle style tags
    params.style?.forEach(({ cssText }) => {
      const el = document.createElement('style')
      el.textContent = cssText
      document.head.appendChild(el)
    })

    // Handle base tag (only one allowed)
    params.base?.forEach(({ href }) => {
      let el = document.head.querySelector<HTMLBaseElement>('base')
      if (!el) {
        el = document.createElement('base')
        document.head.appendChild(el)
      }
      el.setAttribute('href', href)
    })
  }

  return {
    setHead,
  }
}
